import React from "react";

import { css } from "@emotion/react";
import { ContentContainer } from "../_shared-components/arrangement/Container";
import { ComponentIframeType } from "@swo/storefront";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";

export function IframeComponent(props: ComponentIframeType) {
  return (
    <ContentContainer className={getComponentCMSClassname(props?.sys?.id)}>
      <iframe
        src={props.source}
        css={css`
          width: 100%;
          border: 0;
        `}
      ></iframe>
    </ContentContainer>
  );
}
